import { webConversionStages } from "../lib/project-tracking";

export const WEB_CONVERSION_HINT =
  "Die alten Import-Conversions (DHC Lead usw.) in Google Ads auf ‚sekundär‘ stellen.";

/** Google Ads button: creates the website conversions (TASK-243). */
export function WebConversionButton({ pending, onClick }: { pending: boolean; onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={pending}
      className="inline-flex items-center gap-1 rounded-md border border-border-primary px-2 py-1 text-xs text-text-secondary hover:bg-bg-hover disabled:opacity-50"
      title="Legt die Website-Conversions (Lead, Contact, Purchase) im Kundenkonto an und stellt die Server-Meldung darauf um — idempotent, vorhandene werden verwendet"
    >
      {pending ? "lege an…" : "Website-Conversions anlegen"}
    </button>
  );
}

/** Shows which stages report to a website conversion, plus the follow-up for the old ones. */
export function WebConversionNotice({ extraConfig }: { extraConfig: Record<string, unknown> | null | undefined }) {
  const stages = webConversionStages(extraConfig);
  if (stages.length === 0) return null;
  return (
    <p className="basis-full text-xs text-text-secondary">
      Website-Conversion aktiv für: <span className="font-medium text-text-primary">{stages.join(", ")}</span>.{" "}
      {WEB_CONVERSION_HINT}
    </p>
  );
}
